import { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { TopNav } from './TopNav'
import { useAuth } from '@/features/auth/hooks/useAuth'
import { usePostHogIdentify } from '@/lib/analytics'
import { useArtistActivity } from '@/lib/analytics/useArtistActivity'

export function PrivateLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(() => window.matchMedia('(min-width: 1024px)').matches)
  const location = useLocation()
  useEffect(() => { if (!window.matchMedia('(min-width: 1024px)').matches) setSidebarOpen(false) }, [location.pathname])
  const { user } = useAuth()

  // Sync authenticated user to PostHog for analytics tracking
  usePostHogIdentify()
  useArtistActivity()

  if (!user) return null

  return (
    <div className="flex h-screen bg-background">
      {/* Sidebar */}
      <Sidebar open={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} user={user} />
      {sidebarOpen && <button className="fixed inset-0 z-30 bg-black/40 lg:hidden" aria-label="Close navigation backdrop" onClick={() => setSidebarOpen(false)} />}

      {/* Main Content */}
      <div className="min-w-0 flex-1 flex flex-col overflow-hidden">
        {/* Top Navigation */}
        <TopNav user={user} onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} />

        {/* Content */}
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
